
// import axios from 'axios';
import { PluginJS } from "../../api/index"
import { getCategory, getTemplateList,  getTemplateUlists, getTemplateSearch, getTemplateDownload, postTemplateUse, getTemplateInfo, getClicksRank, postComment, PostTemplateClicks/* getServerConfig */} from '../../api/axios/index'
// import { store } from "Store/store.index";


export default class ApiService{

  onLogin = async (parm, callback)=>{
    let data = parm;
    const result = await  PluginJS.callFunction('base', "Login", data)
    callback&&callback(result)
    return result;
  }
  onGetUser = async (parm, callback)=>{
    let data = parm;
    const result = await  PluginJS.callFunction('base', "GetUser", data)
    callback&&callback(result)
    return result;
  }
  onGetTemplateJsonData = async (parm, callback)=>{
    let data = parm;
    const result = await  PluginJS.callFunction('base', "GetTemplateJsonData", data)
    callback&&callback(result)
    return result;
  }
  onOpenFoxitTemplate = async (parm, callback)=>{
    let data = parm;
    const result = await  PluginJS.callFunction('base', "OpenFoxitTemplate", data);
    callback&&callback(result)
    return result;
  }
  onSaveFoxitTemplateJsonData = async (parm, callback)=>{
    let data = parm;
    const result = await  PluginJS.callFunction('base', "SaveFoxitTemplateJsonData", data)
    callback&&callback(result)
    return result;
  }

  apiGetCategory = (parm,callback)=>{
    getCategory(parm).then(res=>{
        callback&&callback(res)
    })
  }
  apiGetTemplateList = (parm,callback)=>{
    getTemplateList(parm).then(res=>{
        callback&&callback(res)
    })
  }
  apiGetTemplateUlists = (parm,callback)=>{
    getTemplateUlists(parm).then(res=>{
        callback&&callback(res)
    })
  }
  apiGetTemplateSearch = (parm,callback)=>{
    getTemplateSearch(parm).then(res=>{
        callback&&callback(res)
    })
  }
  apiGetTemplateDownload = (parm,callback)=>{
    getTemplateDownload(parm).then(res=>{
        callback&&callback(res)
    })
  }
  apiPostTemplateUse = (parm,callback)=>{
    postTemplateUse(parm).then(res=>{
        callback&&callback(res)
    })
  }
  onNavigateTo = async (parm, callback)=>{
    let data = parm;
    const result = await  PluginJS.callFunction('base', "NavigateTo", data);
    callback&&callback(result)
    return result;
  }
  apiGetTemplateInfo = (parm,callback)=>{
    getTemplateInfo(parm).then(res=>{
        callback&&callback(res)
    })
  }
  apiGetClicksRank = (parm,callback)=>{
    getClicksRank(parm).then(res=>{
        callback&&callback(res)
    })
  }
  apiPostComment = (parm,callback)=>{
    postComment(parm).then(res=>{
        callback&&callback(res)
    })
  }
  apiPostTemplateClicks = (parm,callback)=>{
    PostTemplateClicks(parm).then(res=>{
        callback&&callback(res)
    })
  }
}

